import i18n from '../../VueI18n'
import { registryApi } from '../clients/AxiosClients'

/**
 * Retorna todos os EstratoFlorestals cadastradas no banco de dados
 */
const getAllEstratoFlorestais = async (PagNumber = null, PagSize = null, FilteringWord = null) => {
	return registryApi.post('v1/EstratoFlorestal', {
		// Só inclui os parâmetros se eles tiverem valor
		...(PagNumber !== null && { PagNumber }),
		...(PagSize !== null && { PagSize }),
		...(FilteringWord !== null && { FilteringWord }),
	})
}

/**
 * Dropdown para os Estratos Florestais para o componente DropdownFK
 */
const getDropdownEstratosFlorestais = async () => {
	const {
		data: { result },
	} = await registryApi.get('v1/EstratoFlorestal/GetDropdown')

	return result
}

const getDropdownCubagem = async () => {
	const {
		data: { result },
	} = await registryApi.get('/EstratoFlorestal/GetDropdownCubagem')

	return result
}

/**
 * Dropdown para Estratos Florestais para o componente DropdownFK
 * trazendo tambem a fk da fazenda
 */
const getDropdownEstratosFlorestaisComFkFazenda = async () => {
	const {
		data: { result },
	} = await registryApi.get('v1/EstratoFlorestal/GetDropdown')

	return result.map((estratoFlorestal) => {
		return {
			id: estratoFlorestal.id,
			fk_fzda_fazenda: estratoFlorestal.fk_fzda_fazenda,
			[i18n.t('code')]: `EF-${estratoFlorestal.esfl_cd_codigo}`,
			[i18n.t('description')]: estratoFlorestal.esfl_ds_descricao,
			[i18n.t('farm')]: estratoFlorestal.fzda_nm_nome,
		}
	})
}

/**
 * Cadastrar novo EstratoFlorestal no banco de dados
 * @param {Object} body EstratoFlorestal que será cadastrada
 */

const getMaps = async (fazendasIds) => {
	return registryApi.post('v1/PlanejamentoEstratoFlorestal/GetMapsToCreate', fazendasIds)
}
const createEstratoFlorestal = async (body) => {
	return registryApi.post('v1/EstratoFlorestal/Create', body)
}

/**
 * Atualiza EstratoFlorestal no banco de dados
 * @param {Object} body EstratoFlorestal que será atualizada
 */
const updateEstratoFlorestal = async (body) => {
	return registryApi.put('v1/EstratoFlorestal', body)
}

/**
 * Lista dos ids de EstratoFlorestal que devem ser excluidos do banco de dados
 * @param {Array} data Lista dos ids de EstratoFlorestal
 */
const deleteEstratoFlorestalByIdList = async (data) => {
	return registryApi.delete('v1/EstratoFlorestal/DeleteByIdList', { data })
}

export const planejaEstratoFlorestal = async (estratoFlorestal) => {
	return registryApi.post(`v1/PlanejamentoEstratoFlorestal`, estratoFlorestal)
}

export const editaPlanejamentoEstratoFlorestal = async (dto) => {
	return registryApi.put('v1/PlanejamentoEstratoFlorestal', dto)
}

export const getMapsByEstratoFlorestalIdToEdit = async (estratoFlorestalId) => {
	return registryApi.get(
		`v1/PlanejamentoEstratoFlorestal/GetMapsByEstratoFlorestalIdToEdit?estratoFlorestalId=${estratoFlorestalId}`,
	)
}

export {
	createEstratoFlorestal,
	deleteEstratoFlorestalByIdList,
	getAllEstratoFlorestais,
	getDropdownCubagem,
	getDropdownEstratosFlorestais,
	getDropdownEstratosFlorestaisComFkFazenda,
	getMaps,
	updateEstratoFlorestal,
}
